<template>
  <div id="cancel-insurance-modal" v-if="order">
    <el-dialog
      custom-class="cancel-insurance-dialog"
      v-model="showModal"
      :close-on-click-modal="false"
      size="small"
      @close="showModal = false"
      @open="showModal = true"
    >
      <!-- 头部 -->
      <div class="custom-header">
        选择退保人员
        <!-- 关闭 -->
        <div class="el-dialog__headerbtn" @click="showModal = false">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="custom-body">
        <div class="select-all-area">
          <div class="select-all-label">请选择需要退保的申请人</div>
          <div class="select-all-check">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              :disabled="!order.is_support_single"
              >{{ checkAll ? "取消全选" : "全选" }}</el-checkbox
            >
          </div>
        </div>
        <div class="applicant-list-box">
          <div
            class="applicant-list-li"
            v-for="(item, index) in insuranceApplicants"
            :key="index"
            :class="{ active: isActive(item.insurant_id) }"
            @click="handleRowClick(item.insurant_id)"
          >
            <div class="applicant-list-li-left">
              <img
                class="applicant-avatar"
                src="https://o.666visa.cn/static/ssqpeer/order/applicant_default_avatar.png"
              />
              <div class="applicant-list-li-info">
                <div class="applicant-name">{{ item.name }}</div>
                <div class="applicant-passport">
                  护照号码：{{ item.card_code }}
                </div>
              </div>
            </div>
            <div class="applicant-list-li-check" @click.stop>
              <el-checkbox
                :value="checkedApplicants.includes(item.insurant_id)"
                @change="handleItemCheckChange(item.insurant_id)"
                :disabled="!order.is_support_single"
              ></el-checkbox>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="cancel-insurance-footer">
          <el-button
            class="foot-btn"
            type="primary"
            plain
            @click="showModal = false"
            >取消</el-button
          >
          <el-button
            class="foot-btn"
            type="primary"
            :disabled="disabledSubmit"
            @click="handleCancelInsurance"
            :loading="confirmLoading"
            >确认退保</el-button
          >
        </div>
      </template>
    </el-dialog>
    <cancel-insurance-status-modal
      :order="order"
      :type="cancelInsuranceStatusInfo.type"
      :message="cancelInsuranceStatusInfo.message"
      v-model="cancelInsuranceStatusInfo.showModal"
      @close="handleUpdateOrder"
    ></cancel-insurance-status-modal>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import insuranceApi from '../../api/insurance-api';
import cancelInsuranceStatusModal from './cancel-insurance-status-modal.vue';

const INSURANT_STATUS_ENUM = {
  wait_pay: 0,
  not_activated: 1,
  has_effect: 2,
  cancel_ins: 3,
  cancel_success: 4,
};

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    },
  },
  components: { cancelInsuranceStatusModal },
  data() {
    return {
      showModal: this.value, // 是否展示
      checkAll: false,
      isIndeterminate: false,
      activeIndex: 0,
      checkedApplicants: [],
      insuranceApplicants: [],
      cancelInsuranceStatusInfo: {
        type: '',
        showModal: false,
        message: [],
      },
      INSURANT_STATUS_ENUM,
      confirmLoading: false,
    };
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if (newVal && this.order) {
        this.getData();
      }
    },
    showModal(newVal) {
      this.$emit('input', newVal);
    },
  },
  computed: {
    disabledSubmit() {
      return this.checkedApplicants.length === 0;
    },
  },
  methods: {
    handleCheckAllChange() {
      if (this.checkAll) {
        this.checkedApplicants = this.insuranceApplicants.map(
          item => item.insurant_id,
        );
      } else {
        this.checkedApplicants = [];
      }
      this.isIndeterminate = false;
    },
    // 更新全选和半选状态
    updateCheckAllStatus() {
      this.checkAll =
        this.checkedApplicants.length === this.insuranceApplicants.length;
      this.isIndeterminate =
        this.checkedApplicants.length > 0 && !this.checkAll;
    },
    handleItemCheckChange(insurant_id) {
      const index = this.checkedApplicants.indexOf(insurant_id);
      if (index === -1) {
        this.checkedApplicants.push(insurant_id);
      } else if (index > -1) {
        this.checkedApplicants.splice(index, 1);
      }
      // 更新全选和半选状态
      this.updateCheckAllStatus();
    },
    // 整行点击事件
    handleRowClick(insurant_id) {
      if (!this.order.is_support_single) return;
      const index = this.checkedApplicants.indexOf(insurant_id);
      if (index === -1) {
        this.checkedApplicants.push(insurant_id);
      } else {
        this.checkedApplicants.splice(index, 1);
      }
      // 更新全选和半选状态
      this.updateCheckAllStatus();
    },
    // 判断是否为 active 状态
    isActive(insurant_id) {
      return this.checkedApplicants.includes(insurant_id);
    },
    getData() {
      const res = this.order;
      if (res.insurants && res.insurants.length > 0) {
        // 1是未生效
        this.insuranceApplicants = res.insurants.filter(
          item => item.insurant_status === INSURANT_STATUS_ENUM.not_activated,
        );
        // 不支持部分退保的时候默认全选
        if (!this.order.is_support_single) {
          this.checkedApplicants = this.insuranceApplicants.map(
            item => item.insurant_id,
          );
          this.checkAll = true;
          this.isIndeterminate = false;
        }
        // 只有一个申请人的时候默认选中
        if (
          this.order.is_support_single &&
          this.insuranceApplicants &&
          this.insuranceApplicants.length === 1
        ) {
          this.checkedApplicants = [this.insuranceApplicants[0].insurant_id];
          this.checkAll = true;
          this.isIndeterminate = false;
        }
      }

    },
    // 确认退保
    async handleCancelInsurance() {
      sensorsdata.track('ElementClick', {
        pagefrom: 'PC',
        click_content: '保险-取消订单-确认退保',
      });
      try {
        const params = {
          insurance_id: this.order.insurance_id,
          insurant_set: this.checkedApplicants,
        };
        this.confirmLoading = true;
        const res = await insuranceApi.insuranceOrderCancel(params);
        this.confirmLoading = false;
        this.showModal = false;
        this.cancelInsuranceStatusInfo = {
          showModal: true,
          type: 'success',
          message: res.message,
        };
      } catch (error) {
        this.confirmLoading = false;
        console.error(error);
        this.showModal = false;
        this.cancelInsuranceStatusInfo = {
          showModal: true,
          type: 'fail',
          message: [error.msg],
        };
      }
    },
    handleUpdateOrder() {
      this.$emit('refresh');
    },
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable";

#cancel-insurance-modal {
  .cancel-insurance-dialog {
    position: absolute;
    width: 600px;
    top: 50%!important;
    left: 50%;
    transform: translate(-50%, -50%);

    .el-dialog__header {
      display: none;
    }

    .el-checkbox__inner{
      width: 14px;
      height: 14px;
      border-radius: 0;
    }
    .el-checkbox__inner::after {
      top: -1px;
      left: 3.5px;
    }

    .el-dialog__body {
      padding: 0;

      .custom-header {
        height: 60px;
        line-height: 60px;
        display: block;
        padding: 0 20px;
        text-align: center;
        border-bottom: 1px solid #e9eef2;
        font-weight: 500;
        font-size: 18px;
        color: #2f333d;

        .el-dialog__close {
          position: absolute;
          right: 20px;
          top: 16px;
          width: 19px;
          height: 19px;
          transform: rotateZ(45deg);
          cursor: pointer;

          &::before {
            content: "";
            display: block;
            width: 19px;
            position: absolute;
            top: 9px;
            left: 0;
            border-top: 1px solid #777;
          }

          &::after {
            content: "";
            display: block;
            height: 19px;
            position: absolute;
            top: 0;
            left: 9px;
            border-left: 1px solid #777;
          }

          &:hover {
            &::before,
            &::after {
              border-color: @main;
            }
          }
        }
      }

      .custom-body {
        padding: 24px 20px;
        .select-all-area {
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .select-all-label {
            font-size: 14px;
            color: #2f333d;
          }
          .select-all-check {
          }
        }
        .applicant-list-box {
          margin-top: 16px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          .applicant-list-li {
            width: 560px;
            height: 72px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #fafbfc;
            border-radius: 2px;
            border: 1px solid #e9eef2;
            padding: 8px;
            cursor: pointer;
            &.active {
              background: #f3f8ff;
              border: 1px solid #599fff;
            }
            .applicant-list-li-left {
              display: flex;
              justify-content: flex-start;
              gap: 16px;
              .applicant-avatar {
                display: block;
                width: 43px;
                height: 56px;
                background: #ffffff;
                border-radius: 1px;
              }
              .applicant-list-li-info {
                display: flex;
                flex-direction: column;
                gap: 8px;
                .applicant-name {
                  height: 20px;
                  line-height: 20px;
                  font-weight: 400;
                  font-size: 14px;
                  color: #2f333d;
                }
                .applicant-passport {
                  font-size: 12px;
                  color: #91999f;
                }
              }
            }
          }
        }
      }
    }

    .el-dialog__footer {
      padding: 0 100px 32px;
      .cancel-insurance-footer {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .foot-btn {
          width: 180px;
          height: 40px;
          border-radius: 2px;
        }
        .el-button--primary {
          background: #599fff;
          border-color: #599fff;
          color: #fff;
        }
        .el-button.el-button--primary.is-plain {
          border-color: #599fff;
          color: #599fff;
          background: #fff;
        }
        .el-button.is-disabled {
          opacity: 0.6;
        }
      }
    }
  }

  .fc-r {
    color: #ff5a60 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-list/cancel-insurance.vue